/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name  MetricsDimensionAsnameCollDataSource
 * @description
 *
 *     This is supplementary data for MetricsDimension Items. Requires passing of IP or
 *     ipGroups lists to get `asnames`.
 */
angular.module('avi/vs/security').factory('MetricsDimensionAsnameCollDataSource', [
'ListCollDataSource',
function(ListCollDataSource) {
    class MetricsDimensionAsnameCollDataSource extends ListCollDataSource {
        /** @override */
        getRequestParams_() {
            const
                params = { objectName_: 'ipproperties' },
                seriesIds = this.owner_.getItemIds().join();

            if (seriesIds) {
                if ('asname-asn' in this.fields_) {
                    params['asn'] = seriesIds;
                } else if ('asname-ipgroup' in this.fields_) {
                    params['ip'] = seriesIds;
                }
            }

            return params;
        }

        /**
         * Prevents load if we already have all the names.
         * @override
         */
        preventLoad_() {
            const { owner_: collection } = this;

            return !collection.getNumberOfItems() || _.every(
                collection.items, item => item.data.asname,
            );
        }
    }

    angular.extend(MetricsDimensionAsnameCollDataSource.prototype, {
        hasSearch: false,
        hasSorting: false,
        hasPagination: false,
        hasTotalNumberOfItems: false,
        defaultParams_: {},
        defaultFields_: [],
    });

    return MetricsDimensionAsnameCollDataSource;
}]);
